<!-- Button -->
<button mat-icon-button [matMenuTriggerFor]="userActions">
    <span class="relative">
        <img class="w-7 h-7 rounded-full" *ngIf="showAvatar && user?.avatar" [src]="user?.avatar">
        <mat-icon *ngIf="!showAvatar || !user?.avatar" [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
    </span>
</button>

<mat-menu [xPosition]="'before'" #userActions="matMenu">
    <button mat-menu-item (click)="clickProfile()">
        <span class="flex flex-col leading-none">
            <span>{{ 's.l.SignedInAs' | transloco }}</span>
            <span class="mt-1.5 text-md font-medium">{{user?.email}}</span>
        </span>
    </button>
    <!-- <mat-divider class="my-2"></mat-divider> -->
    <!-- <button mat-menu-item (click)="clickProfile()">
        <mat-icon [svgIcon]="'heroicons_outline:user-circle'"></mat-icon>
        <span>{{ 's.l.Profile' | transloco }}</span>
    </button> -->
    <!-- 
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="clickProject()">
        <mat-icon [svgIcon]="'mat_outline:store'"></mat-icon>
        <span>{{ 's.l.HQ' | transloco }}</span>
    </button> -->

    @if (showHQ) {

    @if (hasAppPerm) {
    <mat-divider class="my-2"></mat-divider>
    @if (backLink; as back) {
    <button mat-menu-item (click)="clickBack()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-uturn-left'"></mat-icon>
        <span>{{ back.label }}</span>
    </button>
    }
    <button mat-menu-item (click)="clickApp()">
        <mat-icon [svgIcon]="'mat_outline:apps'"></mat-icon>
        <span>{{ 's.l.AppManagement' | transloco }}</span>
    </button>
    } @else {
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="clickWorkspace()">
        <mat-icon [svgIcon]="'mat_outline:apps'"></mat-icon>
        <span>{{ 's.l.Workspaces' | transloco }}</span>
    </button>
    }

    }

    <!-- Session expiry test tools - dev builds only -->
    @if (isDev) {
    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="devRefreshToken()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-path'"></mat-icon>
        <span>DEV: Refresh token now</span>
    </button>
    <button mat-menu-item (click)="devSimulateNearExpiry()">
        <mat-icon [svgIcon]="'heroicons_outline:clock'"></mat-icon>
        <span>DEV: Arm silent refresh (~10s)</span>
    </button>
    <button mat-menu-item (click)="devSimulateRefreshFailure()">
        <mat-icon [svgIcon]="'heroicons_outline:exclamation-triangle'"></mat-icon>
        <span>DEV: Force expiry dialog (~10s)</span>
    </button>
    }

    <mat-divider class="my-2"></mat-divider>
    <button mat-menu-item (click)="signOut()">
        <mat-icon [svgIcon]="'heroicons_outline:arrow-right-on-rectangle'"></mat-icon>
        <span>{{ 's.l.SignOut' | transloco }}</span>
    </button>
</mat-menu>